/**
 * 素材 相关请求模块
 */
import { api } from '@/commomFun/api'

/**
 * 获取h5审核开关状态
 */
function getH5AuditOpenStatus() {
  return api.getApi('/material/getH5AuditOpenStatus')
}

/**
 * 获取H5审核分享链接
 */
function getAuditShareLink({ planId }) {
  return api.getApi('/material/getAuditShareLink', { planId })
}

/**
 * 发起素材审核（H5审核）
 */
function submitAudit({ planId }) {
  return api.postApi_www('/material/submitAudit', {
    planId
  })
}

/**
 * 撤销素材审核（H5审核）
 */
function revokeAudit({ planId }) {
  return api.postApi_www('/material/revokeAudit', {
    planId
  })
}

/**
 * 校验是否存在待审核记录（H5审核）
 */
function existNotAudit({ planId }) {
  return api.postApi_www('/material/existNotAudit', {
    planId
  })
}

/**
 * 查询素材审核记录（H5审核）
 */
function listAuditRecords({ planId }) {
  return api.getApi('/material/listAuditRecords', { planId })
}

export {
  // 获取h5审核开关状态
  getH5AuditOpenStatus,
  // 获取H5审核分享链接
  getAuditShareLink,
  // 发起素材审核（H5审核）
  submitAudit,
  // 撤销素材审核（H5审核）
  revokeAudit,
  // 校验是否存在待审核记录（H5审核）
  existNotAudit,
  // 查询素材审核记录（H5审核）
  listAuditRecords
}
